import { shallowEqual, TypedUseSelectorHook, useSelector } from "react-redux";
import { AppState } from "redux/store";

export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;

export const useAppShallowEqualSelector = <TSelected>(
  selector: (state: AppState) => TSelected,
) => useAppSelector(selector, shallowEqual);
